import Rails from 'rails-ujs';

if (!window._rails_loaded) { // eslint-disable-line
  Rails.start();
}
